module.exports = __webpack_public_path__ + "img/8v.d2b88e5f.png";